import { ReactNode } from "react";
import { Colors } from "../../../../utils/colors";
import RectangleButton from "../../../Buttons/RectangleButton";
import StandardBorderedContainer from "../../../Containers/StandardBorderedContainer";

type IntegrationPanelContainerProps = {
  isConnected: boolean;
  // The connected state is custom per integration and should fill the container
  connectedContent: ReactNode;
  title: string;
  description: string;
  actionLabel: string;
  onActionPress: () => void;
  actionLoading?: boolean;
  actionDisabled?: boolean;
  actionIconRight?: JSX.Element;
  // Large graphic on the right of the not-connected state
  icon: ReactNode;
};

// Shared shell for the cards on the Integrations tab: the same bordered container and,
// when not connected, the same title, description, action button and right icon.
const IntegrationPanelContainer = (props: IntegrationPanelContainerProps) => {
  const {
    isConnected,
    connectedContent,
    title,
    description,
    actionLabel,
    onActionPress,
    actionLoading,
    actionDisabled,
    actionIconRight,
    icon,
  } = props;

  const styles = {
    overallContainerView: {
      backgroundColor: Colors.WHITE,
      flex: 1,
      width: "100%",
      borderRadius: 20,
      minHeight: 237,
      display: "flex",
      gap: 24,
    },
  };

  return (
    <StandardBorderedContainer containerStyles={styles.overallContainerView}>
      {isConnected ? (
        connectedContent
      ) : (
        <div
          className="AlignedRowSpaced"
          style={{ gap: 24, padding: 24, width: "100%" }}
        >
          <div className="ColumnNormal" style={{ gap: 24 }}>
            <div className="ColumnNormal" style={{ gap: 14 }}>
              <span style={{ fontSize: 20, fontWeight: 500 }}>{title}</span>
              <span className="bodySubtext">{description}</span>
            </div>
            <RectangleButton
              buttonLabel={actionLabel}
              iconRight={actionIconRight}
              onPress={onActionPress}
              disabled={actionDisabled}
              altColor={Colors.BLACK}
              altTextColor={Colors.WHITE}
              altPaddingHorz={24}
              altPaddingVert={14}
              loading={actionLoading}
              containerStyles={{ width: "fit-content", whiteSpace: "nowrap" }}
            />
          </div>
          {icon}
        </div>
      )}
    </StandardBorderedContainer>
  );
};

export default IntegrationPanelContainer;
